import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {shareReplay} from 'rxjs/operators';

import {ApiLocationService} from '@services/api-location/api-location.service';

import {ApiConfiguration} from '@models/machine/api-configuration';
import {Machine} from '@models/machine/machine';
import {TriggerQuery} from '@models/adminstration/machine/trigger/trigger-query/trigger-query';

import {HTTPS_REQUEST_OPTIONS} from '@constants/https-request-options/https-request-options';

@Injectable({
  providedIn: 'root'
})
export class ApiConfigurationService {

  private API_ENDPOINTS_LIST_URL_SUFFIX = '/api/web/admin/machine/:id/apiEndpoints';
  private LIST_AVAILABLE_QUERIES_URL_SUFFIX = '/api/web/admin/machine/:id/triggerConfiguration/listAvailableQueries?externalTriggerApi=true';
  private ADD_API_ENDPOINTS_URL_SUFFIX = '/api/web/admin/machine/:id/apiEndpoints';
  private DELETE_API_ENDPOINTS_URL_SUFFIX = '/api/web/admin/machine/:id/apiEndpoints/:configId';
  private ACTIVATE_API_ENDPOINTS_URL_SUFFIX = '/api/web/admin/machine/:id/apiEndpoints/activateApiEndpoint/:configId';
  private DEACTIVATE_API_ENDPOINTS_URL_SUFFIX = '/api/web/admin/machine/:id/apiEndpoints/deactivateApiEndpoint/:configId';

  private readonly BASE_URL: string;

  constructor(private http: HttpClient,
              private apiLocation: ApiLocationService) {
    this.BASE_URL = this.apiLocation.getLocation();
  }

  public list(machineId: number): Observable<any> {
    let url: string = this.BASE_URL + this.API_ENDPOINTS_LIST_URL_SUFFIX;
    url = url.replace(':id', String(machineId));
    return this.http.get<ApiConfiguration>(url, HTTPS_REQUEST_OPTIONS).pipe(shareReplay({
      bufferSize: 1,
      refCount: true
    }));
  }

  public getAvailableQueries(machineId: number): Observable<any> {
    let url: string = this.BASE_URL + this.LIST_AVAILABLE_QUERIES_URL_SUFFIX;
    url = url.replace(':id', String(machineId));
    return this.http.get<TriggerQuery>(url, HTTPS_REQUEST_OPTIONS).pipe(shareReplay({
      bufferSize: 1,
      refCount: true
    }));
  }

  public saveApiEndpoint(machineId: number | undefined, id: number, isActive: string, maxRequestsPerHour: number, triggerQuery: number, urlSuffix: string): Observable<any> {
    const request = {
      id,
      isActive,
      maxRequestsPerHour,
      triggerQuery,
      url: urlSuffix
    };

    let url: string = this.BASE_URL + this.ADD_API_ENDPOINTS_URL_SUFFIX;
    url = url.replace(':id', String(machineId));
    return this.http.post<ApiConfiguration>(url, request, HTTPS_REQUEST_OPTIONS);
  }

  public delete(machineId: number, configId: number): Observable<any> {
    let url: string = this.BASE_URL + this.DELETE_API_ENDPOINTS_URL_SUFFIX;
    url = url.replace(':id', String(machineId));
    url = url.replace(':configId', String(configId));
    return this.http.delete<ApiConfiguration>(url, HTTPS_REQUEST_OPTIONS);
  }

  public activateEndpoint(machineId: number, configId: number): Observable<any> {
    const request = {
      id: machineId,
      configId
    };
    let url: string = this.BASE_URL + this.ACTIVATE_API_ENDPOINTS_URL_SUFFIX;
    url = url.replace(':id', String(machineId));
    url = url.replace(':configId', String(configId));
    return this.http.post<ApiConfiguration>(url, request, HTTPS_REQUEST_OPTIONS);
  }

  public deactivateEndpoint(machineId: number, configId: number): Observable<any> {
    const request = {
      id: machineId,
      configId
    };
    let url: string = this.BASE_URL + this.DEACTIVATE_API_ENDPOINTS_URL_SUFFIX;
    url = url.replace(':id', String(machineId));
    url = url.replace(':configId', String(configId));
    return this.http.post<ApiConfiguration>(url, request, HTTPS_REQUEST_OPTIONS);
  }

  public getEndpointUrl(machine: Machine, urlSuffix: string): string {
    return 'https://{{api.hostName}}/trigger/api/v1/{{api.machine.parentId}}/{{api.machine.id}}/{{endpoint.url}}'
    .replace('{{api.hostName}}', window.location.hostname)
    .replace('{{api.machine.parentId}}', String(machine.parentId))
    .replace('{{api.machine.id}}', String(machine.id))
    .replace('{{endpoint.url}}', urlSuffix);
  }
}
